
interface Event {
  id: string;
  title: string;
  date: string;
  venue: string;
  ticketUrl: string;
}

interface UpcomingEventsProps {
  events: Event[];
}

export default function UpcomingEvents({ events }: UpcomingEventsProps) {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = date.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Tomorrow';
    if (diffDays < 7) return `In ${diffDays} days`;
    
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
    });
  };

  const handleTicketClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="bg-white rounded-lg border border-neutral-200 p-6">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Upcoming Events</h2>
        <p className="text-sm text-gray-600">
          Catch this artist live
        </p>
      </div>

      <div className="space-y-4">
        {events.map((event) => (
          <div
            key={event.id}
            className="border border-gray-200 rounded-lg p-4 hover:border-emerald-200 hover:bg-emerald-50 transition-colors"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <h3 className="font-semibold text-gray-900 mb-1 line-clamp-2">
                  {event.title}
                </h3>
                <div className="flex items-center text-sm text-gray-600 mb-2">
                  <i className="ri-calendar-line mr-2"></i>
                  {formatDate(event.date)}
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-map-pin-line mr-2"></i>
                  {event.venue}
                </div>
              </div>
            </div>

            <button
              onClick={() => handleTicketClick(event.ticketUrl)}
              className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors whitespace-nowrap"
            >
              <i className="ri-ticket-line mr-2"></i>
              Get Tickets
            </button>
          </div>
        ))}
      </div>

      {events.length === 0 && (
        <div className="text-center py-8">
          <i className="ri-calendar-line text-3xl text-gray-400 mb-3"></i>
          <p className="text-gray-600">No upcoming events</p>
        </div>
      )}
    </section>
  );
}
